import { extendTheme } from "@chakra-ui/react";
import { brandBodyGlobalStyle, brandChakraColors, brandPalette } from "./constants/brandPalette";

export const theme = extendTheme({
  styles: {
    global: {
      body: brandBodyGlobalStyle,
    },
  },
  colors: {
    transparent: "transparent",
    brand: brandChakraColors,
    editorial: {
      primary: brandPalette.primary,
      accent: brandPalette.secondary,
      stroke: brandPalette.stone,
    },
    canvas: brandPalette.cream,
    main_font: brandPalette.taupe,
  },

  fonts: {
    heading: "Baloo 2, cursive",
    body: "Baloo 2, cursive",
  },
});
